
 
export class ViewCompletedOrderColumns {

  public static fields = [
    //{
    //    "fieldName": "applicationId",
    //    "headerText": "Id",
    //    "displayType": "text",
    //    "keyField": true,
    //    "colWidth": "cell-width-1"
    //},
    {
        "fieldName": "customerName",
        "headerText": "Customer Name",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-20"
    },
    {
        "fieldName": "packageName",
        "headerText": "Product Package",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-20"
    },
    {
        "fieldName": "category",
        "headerText": "Category",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-10"
    },
    {
        "fieldName": "activatedOn",
        "headerText": "Activated On",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-5"
    },
    {
        "fieldName": "userId",
        "headerText": "User Id",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-7"
    },
    {
        "fieldName": "agent",
        "headerText": "Agent",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-7"
    },
    {
        "fieldName": "documentCompleted",
        "headerText": "Doc. Completed",
        "displayType": "tick",
        "keyField": false,
        "colWidth": "cell-width-5"
    },
    {
        "fieldName": "paymentNo",
        "headerText": "Payment Voucher No.",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-5"
    },
    {
        "fieldName": "commStatus",
        "headerText": "Comm. Status",
        "displayType": "text",
        "keyField": false,
        "colWidth": ""
    },
    {
        "fieldName": "packageComm",
        "headerText": "Comm. Value (RM)",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-5"
    },
    {
        "fieldName": "agentCommPer",
        "headerText": "Agent Comm. (%)",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-5"
    },
    {
        "fieldName": "agentCommAmount",
        "headerText": "Agent Comm. (RM)",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-5"
    },
    {
        "fieldName": "paidOn",
        "headerText": "Paid On",
        "displayType": "text",
        "keyField": false,
        "colWidth": "cell-width-5"
    }
  ]

}
